/* eslint-disable no-console,no-undef,camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getTimeToShow} from '../../../utils/methods';
import { ImageUrl } from '../../../utils/constants';
import { withTranslation } from 'react-i18next';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { getActiveEvents } from '../../../redux/actions';
import LazyImage from '../../common/LazyImage/LazyImage';
import { ViewEventIcon } from '../../../utils/icons';
// import { EventContainer, ImageContainer, EventContentContainer } from '../MainEvents/SingleChallengeCardV2/styles';
import { EventContentV2, EventContainer, ImageContainer, EventContentContainer } from '../../MainEvents/SingleEventV2/styles';
import dayjs from 'dayjs';

class SingleChallengeCard extends Component {
  constructor() {
    super();
    this.state = {
      time: [],
      showModal: false,
      addToCalendar: 0
    }
  }



  componentDidMount() {
    const { challenge } = this.props;
    this.interval = setInterval(() => {
      this.setState({
        time: getTimeToShow(challenge, 'challenge')
      })
    }, 1000);
    // this.props.getActiveEvents(1);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleEventAttending = (eventId, isAttending) => {
    this.props.attendEvent(eventId, isAttending, 'events');
    this.setState({
      addToCalendar: !this.state.addToCalendar
    })
    this.props.getActiveEvents(1);
  };
  toggleModal = () => {
    this.setState((prev) => ({ showModal: !prev.showModal }))
  }

  onLeaveMouse = () => {
    this.setState({
      onHover: -1,
    });
  };

  onEnterMouse = (id) => {
    this.setState({
      onHover: id,
    });
  };

  render() {
    const { challenge, history, t, length, margin } = this.props;
    const { onHover } = this.state;
    const cardLength = length + 1;
    // const lang = localStorage.getItem("lang");



    return (
      <EventContainer width={this.props.width} margin={(cardLength) % (this.props.cards ? this.props.cards : 3) === 0 ? "0px" : (margin ? margin : "24px")}  onMouseEnter={() => this.onEnterMouse(challenge.id)} onMouseLeave={() => this.onLeaveMouse()} >
        <ImageContainer>
          
          <LazyImage src={`${ImageUrl}/${challenge.image}`} alt={challenge.title} onClick={() => history.push(`/wellness-challenge/${challenge.id}`)}/>
          
        </ImageContainer>
        
        {onHover === challenge.id &&
          <div className='educateImageBackground'>
            <div className="getStarted" 
              style={{ margin:"0px 16px"}}  
              onClick={() =>history.push(`/challenges/wellness-challenge/${challenge.id}`)}
            >
              <span style={{marginRight:"12px"}}>
                {ViewEventIcon()}
              </span>{t("View Challenge")}</div>
          </div>
        }
        
        <EventContentContainer >
          <EventContentV2 padding>
            <div className={"rowContainer"}>
              <span className='title' onClick={() => history.push({ pathname: `/events/${slug}`, state: challenge })} >{t(challenge.title)}</span>
            </div>
            <div className='dateTime'>{dayjs(challenge.challenge_started_at).format("MMMM DD, YYYY")} - {dayjs(challenge.challenge_end_at).format("MMMM DD, YYYY")}</div>
            <div className='pointsEarned' style={{background:"#F8F8F8"}}>
              <span style={{fontSize:"20px"}}>
                {/* <img src={ImageUrl + "/images/emoji/happy-emoji.svg"}/>&nbsp; */}
              </span>{t("You earned ")}<span className='points'>+{challenge?.points_earned} Social Points for Participating</span>
            </div>
            
            {/* <div className='pointsEarned' style={{border:"none",background:"#FCF2F3",color:"#184A61",borderRadius:'4px',gap:"12px",display:"flex",justifyContent:"center",alignItems:"center"}}><span style={{marginLeft:"12px"}}><img src={ImageUrl + "/images/emoji/sad-emoji.svg"}/>&nbsp;</span>{this.props.t("You did not attend")}</div> */}
          </EventContentV2>
        </EventContentContainer>
      </EventContainer>
    )
  }
}

SingleChallengeCard.propTypes = {
  challenge: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  attendEvent: PropTypes.func.isRequired,
  t: PropTypes.func,
  length: PropTypes.number,
  getActiveEvents: PropTypes.func.isRequired,
  activeEvents: PropTypes.array,
  getPastEvents: PropTypes.func.isRequired,
  fetchEvents: PropTypes.func.isRequired,
  width:PropTypes.string,
  cards:PropTypes.number,
  margin:PropTypes.string,
  view:PropTypes.string
};

const mapStateToProps = (state) => ({
  activeEvents: state.events.activeEvents,
});

const mapDispatchToProps = (dispatch) => ({
  getActiveEvents: (pageNumber) => dispatch(getActiveEvents(pageNumber)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SingleChallengeCard)));